import"../../chunk-SDBWQ4EE.js";import{isServer as n}from"lit";const o=(r,s)=>!r||n?"":s.reduce((t,e)=>`${t} ${r.contains(e)?e:""}`,"");export{o as setHostCssClass};
